/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Form, Select, Modal, Input, message } from 'antd';
import emiter, {
	EVENT_CARRENTAL_EMPLOYEE_OPEN_MODAL,
	EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST,
	EVENT_CARRENTAL_ROLE_OPEN_EMPLOYEE
} from '../../../../events';
import { getAllStore, bindStore } from '../../../../hooks/carRental/employee';

interface PropsType {
	enums?: any;
}

const SPAssociatedStoresModal: React.FC<PropsType> = props => {
	const mainFormFields = {
		yuangongxingming: {
			name: 'user_name',
			label: '员工姓名',
			required: false,
		},
		guishumendian: {
			name: 'store_code_list',
			label: '归属门店',
			required: false,
			placeholder: '请选择',
			extra: '该员工仅可查看所选择门店信息',
		},
	};

	const [form] = Form.useForm();
	const [data, setData] = useState<any>();
	const [open, setOpen] = useState(false);
	const [storeList, setStoreList] = useState<any>([]);

	const checkExist = (list: any, currStore: any) => {
		const searchStore = list.filter((item: any) => item.store_code === currStore.store_code);
		if (!searchStore || !searchStore.length) {
			return true;
		}
		return false;
	};

	const mergeStoreList = (list: any) => {
		getAllStore().then((res: any) => {
			setStoreList(res.data);
			if (!list.length) return;
			if (res.data && res.data.length) {
				// 遇到相同的数据保留查询的数据
				const myList: any[] = [];
				list.forEach((item: any) => {
					if (checkExist(res.data, item)) {
						const newStore = { ...item, disabled: true };
						myList.push(newStore);
					}
				});
				setStoreList([...res.data, ...myList]);
			} else {
				list.forEach((item: any) => {
					item.disabled = true;
				});
				setStoreList(list);
			}
		});
	};

	const onOpen = (data: any) => {
		setData(data);
		// 合并storeList
		mergeStoreList(data?.store_list || []);
		const myStoreList: any = [];
		if (data?.store_list && data?.store_list.length) {
			data.store_list.forEach((item: any) => {
				myStoreList.push(item.store_code);
			});
		}
		form.setFieldsValue({
			user_name: data.user_name,
			store_code_list: myStoreList,
		});
		setOpen(true);
	};

	const onClose = () => {
		form.resetFields();
		setOpen(false);
	};

	const onFinish = () => {
		form.validateFields().then((fieldsvalue: any) => {
			bindStore({
				uid: data.uid,
				store_code_list: fieldsvalue.store_code_list,
			}).then((res: any) => {
				if (res.data) {
					message.success('关联成功！');
					onClose();
					emiter.emit(EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST);
				}
			});
		});
	};

	useEffect(() => {
		emiter.on(EVENT_CARRENTAL_EMPLOYEE_OPEN_MODAL, onOpen);
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_EMPLOYEE_OPEN_MODAL)
		}
	}, []);

	return (
		<Modal title="关联门店" centered open={open} onOk={onFinish} onCancel={onClose}>
			<Form form={form}>
				<Form.Item name={mainFormFields.yuangongxingming.name} label={mainFormFields.yuangongxingming.label}>
					<Input disabled />
				</Form.Item>
				<Form.Item name={mainFormFields.guishumendian.name} label={mainFormFields.guishumendian.label}>
					<Select placeholder={mainFormFields.guishumendian.placeholder} mode="multiple" showSearch={false}>
						{storeList &&
							storeList.map((item: any) => (
								<Select.Option value={item.store_code} key={item.store_code} disabled={item.disabled}>
									{item.store_name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default SPAssociatedStoresModal;
